import {
  commonColumns,
  surveyAssetsColumns,
  taxAuthorityColumns,
  crawlerTab5Columns
} from 'common/constants/gridColumns';

const getColumnHeader = (columnName, columns) => {
  const [column] = columns.filter(col => col.accessor === columnName);

  return column.Header;
}

export const getCommonAssetsColumnHeader = columnName => getColumnHeader(columnName, commonColumns);
export const getTaxAuthorityColumnHeader = columnName => getColumnHeader(columnName, taxAuthorityColumns);
export const getSimilarAssetsCrawlerColumnHeader = columnName => getColumnHeader(columnName, crawlerTab5Columns);
export const getSurveyAssetsColumnHeader = columnName => getColumnHeader(columnName, surveyAssetsColumns);
